"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/hooks/useScript.ts
var useScript_exports = {};
__export(useScript_exports, {
  useScript: () => useScript
});
module.exports = __toCommonJS(useScript_exports);
var import_react = require("react");
var cachedScripts = [];
var useScript = (src, attributes = {}) => {
  const [state, setState] = (0, import_react.useState)({
    loaded: false,
    error: false
  });
  (0, import_react.useEffect)(() => {
    if (!src)
      return;
    if (cachedScripts.includes(src)) {
      setState({
        loaded: true,
        error: false
      });
      return;
    } else {
      cachedScripts.push(src);
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      for (const key in attributes) {
        script.setAttribute(key, attributes[key]);
      }
      const onScriptLoad = () => {
        setState({
          loaded: true,
          error: false
        });
      };
      const onScriptError = () => {
        const index = cachedScripts.indexOf(src);
        if (index >= 0)
          cachedScripts.splice(index, 1);
        script.remove();
        setState({
          loaded: true,
          error: true
        });
      };
      script.addEventListener("load", onScriptLoad);
      script.addEventListener("error", onScriptError);
      document.body.appendChild(script);
      return () => {
        script.removeEventListener("load", onScriptLoad);
        script.removeEventListener("error", onScriptError);
      };
    }
  }, [src]);
  return [state.loaded, state.error];
};
